import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import isValidEmail from "../../../utils/isValidEmail";
import Error from "../../Error";
import { useGetUserQuery } from "../../features/auth/authApi";
import {
  useAddMemberMutation,
  useGetTeamQuery,
} from "../../features/team/teamApi";
import { closeModal } from "../../features/team/teamSlice";

export default function ModalForAddingMember() {
  const { team } = useSelector((state) => state.team);
  const [memberEmail, setMemberEmail] = useState("");
  const [userCheck, setUserCheck] = useState(false);
  const [status, setStatus] = useState(false);
  const [teamCheck, setTeamCheck] = useState(false);
  const [responseError, setResponseError] = useState("");
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};
  const { data: participant, isSuccess } = useGetUserQuery(memberEmail, {
    skip: !userCheck,
  });
  const dispatch = useDispatch();
  const [addMember, { isSuccess: success }] = useAddMemberMutation();
  const { data: teamDetails, isSuccess: getTeamSuccess } = useGetTeamQuery(
    team.id,
    {
      skip: !teamCheck,
    }
  );
  useEffect(() => {
    if (isSuccess && getTeamSuccess) {
      if (participant?.length === 0) {
        setResponseError("Theres's no user using these email.");
      }
      if (teamDetails) {
        console.log(teamDetails);
        const { members } = teamDetails;
        if (members.includes(`-${memberEmail}`)) {
          setStatus(true);
          setResponseError("Already a member of this team.");
        } else {
          setStatus(false);
        }
      }
      if (
        participant?.length !== 0 &&
        memberEmail !== myEmail &&
        status !== true
      ) {
        setResponseError("");
      }
      if (success) {
        setTeamCheck(false);
        dispatch(closeModal());
      }
    }
  }, [
    isSuccess,
    dispatch,
    status,
    participant,
    success,
    memberEmail,
    getTeamSuccess,
    teamDetails,
    myEmail,
  ]);
  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };
  const doSearch = (value) => {
    if (isValidEmail(value)) {
      setUserCheck(true);
      setTeamCheck(true);
      setMemberEmail(value);
    }
  };
  const handleSearch = debounceHandler(doSearch, 500);

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = team.id;
    const data = {
      name: teamDetails.name,
      date: teamDetails.date,
      color: teamDetails.color,
      description: teamDetails.description,
      members: `${teamDetails.members}-${memberEmail}`,
      id: team.id,
    };
    addMember({ id, data });
  };

  return (
    <>
      <div className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"></div>
      <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
        <span
          onClick={() => dispatch(closeModal())}
          className="absolute cursor-pointer top-[-4px] text-xl text-white right-[-3px] bg-red-400 rounded-2xl py-1 text-center font-bold px-3"
        >
          X
        </span>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Add New Member To The{" "}
          <span className="text-red-400">{team.name}</span> Team
        </h2>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only"></label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                placeholder="Enter email"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              disabled={responseError}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Add Member
            </button>
          </div>
          {responseError && <Error message={responseError} />}
        </form>
      </div>
    </>
  );
}
